import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
} from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { animations } from "./prices-table-category-item.animations";
import { IPricesTableCategoryItemsItem } from "../prices-table-category-items/prices-table-category-items.component";

export interface IPricesTableCategoryItem {
  bodyColor: IUProperty<string>;
  categoryName: IUProperty<string>;
  items: IUProperty<IPricesTableCategoryItemsItem[]>;
  textColor: IUProperty<string>;
  state: AccordionItemStateEnum;
}

export enum AccordionItemStateEnum {
  Opened = 'opened',
  Closed = 'closed'
}

@Component({
  selector: "app-prices-table-category-item",
  templateUrl: "./prices-table-category-item.component.html",
  styleUrls: ["./prices-table-category-item.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations,
})
export class PricesTableCategoryItemComponent implements OnInit, AfterViewInit {
  @Input() item: IPricesTableCategoryItem;
  @Input() isFirst: boolean;

  accordionItemState = AccordionItemStateEnum;

  constructor(private hostRef: ElementRef) {}

  ngOnInit(): void {
    this.item.state = this.isFirst ? AccordionItemStateEnum.Opened : AccordionItemStateEnum.Closed;
  }

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  handleToggleItem(item: IPricesTableCategoryItem) {
    if (item.state === AccordionItemStateEnum.Opened) {
      item.state = this.accordionItemState.Closed;
    } else {
      item.state = this.accordionItemState.Opened;
    }
  }

  private setCustomThemeProperties(d: IPricesTableCategoryItem) {
    if (d.bodyColor && d.bodyColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--category-item-body-color",
        d.bodyColor.value
      );
    }

    if (d.textColor && d.textColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--category-item-text-color",
        d.textColor.value
      );
    }
  }
}
